// import { BehaviorSubject } from 'rxjs';
import Utils from '../utils'
// import Auth from '../utils/auth'

// const currentUserSubject = new BehaviorSubject(Auth.getToken());
export const userService = {
    getUserData,
};

function getUserData() {    
    return Utils.getLocalStorageItem('currentUser');
}
